"use client";

import Link from "next/link";
import { useTranslations } from "next-intl";
import ErrorPage from "@components/error";

// Error components must be Client Components

export default function Error({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  const t = useTranslations("GenrePage.error");

  return (
    <ErrorPage
      heading={
        <>
          <span className="sr-only">{t("error")}</span>
          {t("oops")}
        </>
      }
      subheading={error.message}
      bodyText={t.rich("dontworrywithcontactlink", {
        button: (chunks) => (
          <Link
            href={"/contact"}
            className="text-black underline font-semibold"
          >
            {chunks}
          </Link>
        ),
      })}
      reset={reset}
    />
  );
}
